var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "barrel",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m50,43.683c-3.522,0-6.388,2.834-6.388,6.317s2.865,6.317,6.388,6.317,6.389-2.834,6.389-6.317-2.866-6.317-6.389-6.317Zm0,10.635c-2.419,0-4.388-1.937-4.388-4.317s1.969-4.317,4.388-4.317,4.389,1.937,4.389,4.317-1.969,4.317-4.389,4.317Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m50,9c-22.056,0-40,17.944-40,40s17.944,40,40,40,40-17.944,40-40S72.056,9,50,9Zm27.548,66.134l-4.947-4.946c4.99-5.32,8.126-12.394,8.375-20.187h6.999c-.253,9.722-4.172,18.543-10.427,25.134ZM12.025,50h6.999c.249,7.794,3.384,14.867,8.375,20.187l-4.947,4.946c-6.255-6.591-10.174-15.411-10.427-25.134Zm10.427-27.133l4.947,4.947c-4.991,5.32-8.126,12.393-8.375,20.187h-6.999c.253-9.722,4.171-18.543,10.427-25.133Zm40.31,52.168V22.966c9.609,4.729,16.239,14.62,16.239,26.034s-6.63,21.305-16.239,26.034Zm-12.762,2.967c-3.906,0-7.631-.781-11.035-2.187V22.186c3.404-1.406,7.129-2.187,11.035-2.187,3.806,0,7.439.744,10.772,2.083,0,.017-.01.032-.01.049v53.791c-3.33,1.336-6.96,2.079-10.762,2.079Zm-29.001-29.001c0-11.304,6.506-21.112,15.966-25.894v51.788c-9.46-4.782-15.966-14.59-15.966-25.894Zm50.188-22.601c-5.32-4.99-12.393-8.126-20.187-8.374v-7c9.722.253,18.543,4.172,25.134,10.427l-4.947,4.947Zm-22.187-8.374c-7.793.249-14.866,3.384-20.187,8.374l-4.947-4.947c6.591-6.256,15.411-10.174,25.134-10.427v7Zm-20.187,53.576c5.32,4.99,12.393,8.126,20.187,8.374v6.999c-9.722-.253-18.543-4.172-25.134-10.427l4.947-4.947Zm22.187,8.374c7.793-.249,14.866-3.384,20.187-8.374l4.947,4.947c-6.591,6.255-15.411,10.174-25.134,10.427v-6.999Zm29.976-31.976c-.249-7.793-3.384-14.866-8.375-20.187l4.947-4.947c6.255,6.591,10.174,15.411,10.427,25.133h-6.999Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }